import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

let yearTerm
if (localStorage.getItem('yearTerm') != 'undefined' && localStorage.getItem('yearTerm')) {
  yearTerm = JSON.parse(localStorage.getItem('yearTerm'))
}

const store = new Vuex.Store({
  state: {
    paramsData: {
      schoolYear: yearTerm ? yearTerm.year : 2023,
      term: yearTerm ? yearTerm.term : 1,
    }
  }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js